import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useStateRef } from 'app/services';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useForm } from 'react-hook-form';

const GeofenceGroupForm = forwardRef(function (props, ref) {
  const theme = useTheme();
  const [color, setColor] = useState(defaultValues?.color ?? theme.palette.primary.main);
  const [firstUpdate, setFirstUpdate, firstUpdateRef] = useStateRef(!!defaultValues);
  const { defaultValues, onSubmit } = props;
  const { reset, register, setValue, formState, handleSubmit } = useForm({
    defaultValues: {
      name: defaultValues ? defaultValues.name : '',
      color: defaultValues ? defaultValues.color : theme.palette.primary.main,
    },
  });

  const handleColorChange = (value) => {
    setColor(value);
    setValue('color', value, { shouldDirty: true });
  };

  useImperativeHandle(ref, () => ({
    handleFormSubmit: () => {
      handleSubmit((data) =>
        onSubmit({
          name: data.name,
          color: data.color,
        })
      )();
    },
  }));

  useLayoutEffect(() => {
    if (firstUpdateRef.current !== undefined) {
      setTimeout(() => setFirstUpdate(undefined), theme.transitions.duration.shorter);
    }
  }, [firstUpdateRef.current]);

  useEffect(() => {
    if (defaultValues) {
      reset({
        name: defaultValues.name,
        color: defaultValues.color,
      });

      setColor(defaultValues.color);
    }
  }, [defaultValues]);

  return (
    <form>
      <FormControl error={!!formState.errors.name} margin='normal' variant='outlined' fullWidth>
        <InputLabel disableAnimation={firstUpdate}>Название</InputLabel>
        <OutlinedInput
          label='Название'
          placeholder='Название группы'
          variant='outlined'
          notched={firstUpdate}
          fullWidth
          {...register('name', {
            pattern: /^([A-Za-zА-Яа-я0-9_\-\s]{3,255})$/iu,
            required: true,
            minLength: 3,
          })}></OutlinedInput>
        <FormHelperText>Используйте в названии не менее 3 символов</FormHelperText>
      </FormControl>
      <FormControl
        error={!!formState.errors.color}
        margin='normal'
        variant='outlined'
        fullWidth
        sx={(theme) => ({
          marginBottom: theme.spacing(0),
          '.MuiOutlinedInput-notchedOutline': {
            borderBottom: '0',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
          },
          '.MuiOutlinedInput-root': {
            color: 'text.primary',
          },
          '.MuiOutlinedInput-input': {
            WebkitTextFillColor: 'currentColor',
          },
        })}>
        <InputLabel disableAnimation>Цвет заливки</InputLabel>
        <OutlinedInput
          label='Цвет заливки'
          placeholder='Цвет заливки'
          variant='outlined'
          value={color}
          disabled
          notched
          fullWidth></OutlinedInput>
      </FormControl>
      <FormControl
        margin='normal'
        variant='outlined'
        fullWidth
        sx={(theme) => ({
          marginTop: '0',
          '.react-colorful': {
            width: '100%',
            borderBottomLeftRadius: theme.shape.borderRadius * 2,
            borderBottomRightRadius: theme.shape.borderRadius * 2,
          },
          '.react-colorful__saturation': {
            boxShadow: 'inset 0px -1px 0px 1px rgb(0 0 0 / 15%)',
            borderRadius: '0',
          },
          '.react-colorful__last-control': {
            borderRadius: '0',
            borderBottomLeftRadius: theme.shape.borderRadius * 2,
            borderBottomRightRadius: theme.shape.borderRadius * 2,
          },
        })}>
        <HexColorPicker color={color} onChange={handleColorChange} />
        <FormHelperText>
          Выберите цвет из палитры, который будет использоваться для отображения цвета заливки геозоны на карте.
        </FormHelperText>
      </FormControl>
    </form>
  );
});

export default GeofenceGroupForm;
